import React from 'react';
import icons from './icons';
import classNames from 'classnames';
import Translator from 'bazinga-translator';

export default class Person extends React.Component {
    constructor() {
        super();
        this.state = { disabled: true, name: null, email: null, phone: null };
        this.getAllInputdata = this.getAllInputdata.bind(this);
        this.setEditable = this.setEditable.bind(this);
        this.saveChanges = this.saveChanges.bind(this);
        this.deletePerson = this.deletePerson.bind(this);
        this.handleDefaultPersonChange = this.handleDefaultPersonChange.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handlePhoneChange = this.handlePhoneChange.bind(this);
    }

    componentDidMount() {
        this.setState({
            name: this.props.person.name,
            email: this.props.person.email,
            phone: this.props.person.phone
        });
    }


    getValuesWithDeleted(persons, key){
        return persons.filter(person=>{
            return person.key !== key
        })
    }

    handleNameChange(e){
        this.setState({
            name: e.target.value
        })
    }

    handleEmailChange(e){
        this.setState({
            email: e.target.value
        })
    }

    handlePhoneChange(e){
        this.setState({
            phone: e.target.value
        })
    }

    setEditable(e) {
        e.preventDefault();
        this.setState({
            ...this.state,
            disabled: false
        });
    }

    saveChanges(e) {
        e.preventDefault();
        const { actions, person } = this.props;
        const values = this.getAllInputdata();
        actions.saveChanges(person.key, values);
        this.setState({
            ...this.state,
            disabled: true
        });
    }
    getAllInputdata() {
        return {
            name: this.refs.name.value,
            email: this.refs.email.value,
            phone: this.refs.phone.value
        }
    }

    handleDefaultPersonChange() {
        const { actions,person } = this.props;
        if(person.default !== true) {
            actions.changeDefaultPerson(person.key);
        }
    }
    
    deletePerson(e) {
        const { actions,person } = this.props;
        actions.deletePerson(parseInt(person.key));
        this.saveChanges(e);
    }

    render() {
        const { person } = this.props;
        const { disabled } = this.state;
        let containerClass = classNames({
            'contact-person': true,
            '-disabled': this.state.disabled
        });
        return (
        <div className={containerClass}>
            <div className="contact-person__col">
                {icons.personIcon}
                <div className="input">
                    <label htmlFor="name">{Translator.trans('edit_mode.modal.clients.contact_person.name', [], 'app')}<em>*</em></label>
                    <input type="text"
                           id="name"
                           value={this.state.name}
                           defaultValue={this.state.name}
                           onChange={this.handleNameChange}
                           disabled={disabled} ref="name"
                    />
                </div>
            </div>
            <div className="contact-person__col">
                <div className="input">
                    <label htmlFor="e-mail">{Translator.trans('edit_mode.modal.clients.contact_person.email', [], 'app')}<em>*</em></label>
                    <input type="text"
                           id="e-mail"
                           value={this.state.email}
                           onChange={this.handleEmailChange}
                           disabled={disabled}
                           ref="email"
                    />
                </div>
            </div>
            <div className="contact-person__small-col">
                <div className="input">
                    <label htmlFor="phone">{Translator.trans('edit_mode.modal.clients.contact_person.phone', [], 'app')}</label>
                    <input type="text" id="phone"
                           value={this.state.phone}
                           onChange={this.handlePhoneChange}
                           ref="phone"
                           disabled={disabled}
                    />
                </div>
            </div>
            <div className="contact-person__options">
                <div className="input">
                    <p>{Translator.trans('edit_mode.modal.clients.contact_person.default', [], 'app')}</p>
                    <input type="radio"
                           id={`personDefault_${person.key}`}
                           name="contactForm"
                           ref="default"
                           checked={person.default}
                           onChange={this.handleDefaultPersonChange}

                    />
                    <label htmlFor={`personDefault_${person.key}`}><span>
                        <span></span>
                    </span>
                    </label>
                </div>
                <div>
                    <a href="#" className="opt-mini -border" onClick={this.setEditable} title={Translator.trans('edit_mode.modal.clients.contact_person.edit', [], 'app')}>
                        {icons.editIcon} <p>{Translator.trans('edit_mode.modal.clients.contact_person.edit', [], 'app')}</p>
                    </a>
                    <a href="#" className="opt-mini -border" onClick={this.deletePerson} id="asdasd" title={Translator.trans('edit_mode.modal.clients.contact_person.remove', [], 'app')}>
                        {icons.deleteIcon}
                    </a>
                </div>
                <a href="#" className="btn -full" onClick={this.saveChanges}>{Translator.trans('edit_mode.modal.clients.contact_person.save', [], 'app')}</a>
            </div>
        </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/_app/clients/components/person.jsx